const UploadIcon = () => (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M16 8l-4-4m0 0L8 8m4-4v12"
        />
    </svg>
);

const ImageUploadButton = ({ onPick, onReset, canReset = false, label = "Upload" }) => (
    <div className="flex items-center gap-2">
        <label className="cursor-pointer px-3 py-1.5 bg-charleston-green text-white border border-zinc-700 rounded-full hover:bg-zinc-800 flex items-center gap-2 text-sm transition-colors">
            <UploadIcon />
            <span>{label}</span>
            <input
                type="file"
                accept="image/*"
                className="hidden"
                onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (!file) return;
                    const reader = new FileReader();
                    reader.onload = () => onPick(reader.result);
                    reader.readAsDataURL(file);
                    e.target.value = "";
                }}
            />
        </label>
        {canReset && (
            <button
                type="button"
                onClick={onReset}
                className="text-xs text-zinc-500 hover:text-white transition-colors"
            >
                Reset
            </button>
        )}
    </div>
);

export default ImageUploadButton;
